import { irA } from '../../lib/ruta';
import { textos } from '../../textos';
import { Btn } from '../../components/ui/Btn';
import { loginUrl } from '../session/api';

const PASOS = [textos.inicio.paso1, textos.inicio.paso2, textos.inicio.paso3] as const;

/**
 * Presentación de la dirección principal. El acceso de un cliente
 * (escanear y entrar) vive en su subdominio, no aquí.
 */
export function InicioPublico(props: {
  readonly esDesarrollo: boolean;
  readonly aviso: string | null;
  readonly onEntrarLocal: (correo: 'admin@local' | 'operario@local') => void;
}): React.JSX.Element {
  return (
    <main className="min-h-dvh bg-brand-surface text-brand-text" translate="no">
      <div className="mx-auto flex min-h-dvh w-full max-w-lg flex-col justify-center gap-8 px-6 py-12">
        <header className="flex flex-col gap-3">
          <p className="text-sm font-semibold tracking-wide text-brand-secondary">{textos.app.nombre}</p>
          <h1 className="text-3xl font-semibold leading-tight">{textos.inicio.titulo}</h1>
          <p className="text-brand-text-muted">{textos.inicio.bajada}</p>
        </header>
        <ol className="flex flex-col gap-3">
          {PASOS.map((paso, i) => (
            <li key={paso} className="flex items-start gap-3">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-secondary text-sm font-semibold text-brand-secondary-fg">
                {i + 1}
              </span>
              <span className="pt-0.5">{paso}</span>
            </li>
          ))}
        </ol>
        <div className="flex flex-col gap-3">
          {props.esDesarrollo ? (
            <>
              <Btn variante="primario" onClick={() => props.onEntrarLocal('admin@local')}>
                {textos.acciones.entrarLocalAdmin}
              </Btn>
              <Btn variante="secundario" onClick={() => props.onEntrarLocal('operario@local')}>
                {textos.acciones.entrarLocalOperario}
              </Btn>
            </>
          ) : (
            <Btn variante="primario" onClick={() => window.location.assign(loginUrl())}>
              {textos.acciones.iniciarSesion}
            </Btn>
          )}
          <Btn variante="escanear" onClick={() => irA('/identificar')}>
            {textos.inicio.identificar}
          </Btn>
        </div>
        {props.aviso ? <p className="text-brand-danger">{props.aviso}</p> : null}
        <p className="text-sm text-brand-text-muted">{textos.inicio.direccionPropia}</p>
      </div>
    </main>
  );
}
